import { Carte, Faits } from './DossierCarte';
import type { Dossier } from '../SuiviPrivatisationLayout';

const fmtDate = (d?: string | null) => {
    if (!d) return '—';
    try { return new Date(d).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }); } catch { return '—'; }
};
const fmtHeure = (d?: string | null) => {
    if (!d) return '—';
    try { return new Date(d).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }); } catch { return '—'; }
};
const fmtMontant = (n?: number | null) =>
    typeof n === 'number' && n > 0 ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n) : '—';

/**
 * Les deux blocs de faits de la maquette 18a, « Le client » et « Le service » — avec ce que le dossier
 * sait VRAIMENT. La maquette montrait une fiche CRM reliée, une origine, une salle et une heure de
 * service à table : rien de tout cela n'existe sur le dossier, on ne l'invente pas.
 *
 * Avant la création de la privatisation, « Le service » n'a ni date ni couverts : « pas encore fixée »
 * dit la vérité du dossier, là où un tiret laisserait croire à une donnée perdue.
 */
export function ClientCard({ dossier }: { dossier: Dossier }) {
    const pro = dossier.type === 'PROFESSIONNEL';
    const lignes: [string, string][] = [];
    if (pro && dossier.company_name) lignes.push(['Société', dossier.company_name]);
    const contact = [dossier.first_name, dossier.last_name].filter(Boolean).join(' ');
    if (contact) lignes.push(['Contact', contact]);
    lignes.push(['Téléphone', dossier.phone || '—']);
    lignes.push(['Courriel', dossier.email || '—']);
    // Le référent reste distinct du standard : c'est LUI qu'on rappelle (demande d'Emeni, 2026-08-30).
    if (dossier.organizer_name || dossier.organizer_phone || dossier.organizer_email) {
        lignes.push(['Référent', [dossier.organizer_name, dossier.organizer_phone, dossier.organizer_email].filter(Boolean).join(' · ')]);
    }
    lignes.push(['Type', pro ? 'Professionnel' : 'Particulier']);
    return <Carte titre="Le client"><Faits lignes={lignes} /></Carte>;
}

export function ServiceCard({ dossier }: { dossier: Dossier }) {
    const ev = dossier.event;
    const lignes: [string, string][] = [
        ['Date de la privatisation', ev ? fmtDate(ev.start_time) : 'pas encore fixée'],
        ['Arrivée des convives', ev ? fmtHeure(ev.start_time) : '—'],
        ['Fin de prestation', ev ? fmtHeure(ev.end_time) : '—'],
        ['Couverts', ev?.num_people ? String(ev.num_people) : '—'],
        ['Formule retenue', dossier.formule_retenue || '—'],
        ['Montant du devis', fmtMontant(dossier.devis_amount_ttc)],
    ];
    return <Carte titre="Le service"><Faits lignes={lignes} /></Carte>;
}
